// Adresse réelle du client d'un dossier, pour lui écrire. Les commandes des sites Inde (source « externe_… ») sont
// rattachées à un compte « externe.<email> » (backend client, externeRoutes.js), qui n'est pas une vraie boîte :
// les mails doivent partir à <email>. Même règle que SQL_EMAIL_CLIENT du backend admin (server.js).
// Le compte lui-même (recherche « Informations du client ») garde son adresse préfixée.
export const adresseClient = (email?: string | null, source?: string | null): string => {
  const adresse = email || '';
  if ((source || '').startsWith('externe') && adresse.toLowerCase().startsWith('externe.')) {
    return adresse.slice('externe.'.length);
  }
  return adresse;
};
